module.exports = __webpack_public_path__ + "static/img/about-us.d8d5acd4.jpg";